import {
    SIGN_UP,
    LOG_IN,
    LOG_OUT,
    GET_RECOVERY_LINK,
    CHANGE_PASSWORD_REQUEST,
    RESET_PASSWORD,
    GET_MY_PROFILE,
    INVITE_USER, RESET_PASSWORD_USER_EMPLOY,
} from "./auth.types";

export const signUp = (body) => {
    return {
        type: SIGN_UP,
        payload: {body},
    };
};

export const logIn = (user) => {
    return {
        type: LOG_IN,
        payload: user,
    };
};

export const logOut = () => {
    return {
        type: LOG_OUT,
    };
};

export const getMyProfile = (type) => {
    return {
        type: GET_MY_PROFILE,
        payload: {type},
    };
};

export const getRecoveryLink = (email) => {
    return {
        type: GET_RECOVERY_LINK,
        payload: {email},
    };
};

export const resetPassword = (passwords) => {
    return {
        type: RESET_PASSWORD,
        payload: {passwords},
    };
};

export const changePassword = (data) => {
    return {
        type: CHANGE_PASSWORD_REQUEST,
        payload: {data},
    };
};

export const inviteUser = (params) => {
    return {
        type: INVITE_USER,
        payload: params,
    };
};


export const resetPasswordUserEmploy = (id, body) => {
    return {
        type: RESET_PASSWORD_USER_EMPLOY,
        payload: {id, body},
    };
};
